import * as React from 'react'

export const ElaMenuHandler = React.lazy(
  () => import('@freckle/student/ts/ela/menu/components/ela-menu')
)
export const WordStudyIntroDebugHandler = React.lazy(
  () => import('@freckle/student/ts/ela/word-study/debug/components/word-study-intro-debug-handler')
)
export const WordStudyDebugHandlerComponent = React.lazy(
  () => import('@freckle/student/ts/ela/word-study/debug/components/word-study-debug-handler')
)
export const ElaArticlesCategoriesHandler = React.lazy(
  () => import('@freckle/student/ts/ela/articles/components/ela-articles-categories')
)
export const ElaContentLibraryHandler = React.lazy(
  () => import('@freckle/student/ts/ela/articles/components/ela-content-library')
)
export const ElaArticlesCategoryHandler = React.lazy(
  () => import('@freckle/student/ts/ela/articles/components/ela-articles-category')
)
export const ElaSkillPracticeDomainsHandler = React.lazy(
  () => import('@freckle/student/ts/ela/skills-practice/components/domains')
)
export const ElaSkillPracticeDomainHandler = React.lazy(
  () => import('@freckle/student/ts/ela/skills-practice/components/domain')
)
export const ElaSkillsPracticeSessionHandler = React.lazy(
  () => import('@freckle/student/ts/ela/skills-practice/components/session')
)
export const ElaTargetedSkillsPracticeSessionHandler = React.lazy(
  () => import('@freckle/student/ts/ela/skills-practice/components/targeted-session')
)
export const ElaSkillsPracticeDebugHandler = React.lazy(
  () => import('@freckle/student/ts/ela/skills-practice/components/debug')
)
export const ElaWritingAssignmentHandler = React.lazy(
  () => import('@freckle/student/ts/ela/writing/components')
)
export const ElaReadingAssignmentResumableContainer = React.lazy(
  () => import('@freckle/student/ts/ela/reading/components/ela-reading-assignment-resumable')
)
export const ElaAssessmentSessionHandler = React.lazy(
  () => import('@freckle/student/ts/ela/assessment/components')
)
export const ElaSelfReadingAssignmentHandler = React.lazy(
  () => import('@freckle/student/ts/ela/assignments/components/ela-self-assigned-assignment')
)
export const WordStudyBriefingHandler = React.lazy(
  () => import('@freckle/student/ts/ela/word-study/briefing/components')
)
export const SightWordsHandler = React.lazy(
  () => import('@freckle/student/ts/ela/sight-words/components')
)
export const ElaDiagnosticHandler = React.lazy(
  () => import('@freckle/student/ts/ela/diagnostic/components')
)
export const DecodablesBriefingHandler = React.lazy(
  () => import('@freckle/student/ts/ela/decodables/components/decodables-briefing')
)
export const DecodableHandlerSelf = React.lazy(
  () => import('@freckle/student/ts/ela/decodables/components/decodable/self')
)
export const DecodableHandlerTeacher = React.lazy(
  () => import('@freckle/student/ts/ela/decodables/components/decodable/teacher')
)
export const WordStudySessionHandler = React.lazy(
  () => import('@freckle/student/ts/ela/word-study/session/components/word-study-session-handler')
)
export const WordStudySelfAssignedSessionHandler = React.lazy(
  () =>
    import('@freckle/student/ts/ela/word-study/session/components/self-assigned-session-handler')
)
export const ElaTargetedSelfAssignedHandler = React.lazy(
  () => import('@freckle/student/ts/ela/targeted/session/components/self-assigned-session-handler')
)
export const WordStudyDiagnosticHandler = React.lazy(
  () => import('@freckle/student/ts/ela/word-study/diagnostic/components/index')
)
export const DomainPathwayHandler = React.lazy(
  () => import('@freckle/student/ts/ela/skills-practice/components/pathway')
)
export const FocusSkillsPracticeHandler = React.lazy(
  () => import('@freckle/student/ts/focus-skills-practice/components/focus-skills-practice-handler')
)
export const ElaFocusSkillsPracticeSessionHandler = React.lazy(
  () => import('@freckle/student/ts/focus-skills-practice/ela/session-handler')
)
